export default __webpack_public_path__ + "static/media/CT_Tmobile.7f1e35d4.png";